import "./assets/scss/style.scss";
import * as React from "react";
import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { useLocation, useRoutes, Navigate } from "react-router-dom";
import Loading from "./components/Loading";
import { Home } from "./pages/home";
import { Lobby } from "./pages/lobby";
import { Lounge } from "./pages/lounge";
import { Privateroom } from "./pages/privateroom";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const setCookie = (name, value, options = {}) => {
    return cookies.set(name, value, { ...options });
};

export const getCookie = (name) => {
    return cookies.get(name);
};

export default function App() {
    const [visited, setvisited] = useState(true); // 방문 상태를 관리합니다.
    const [currentPageCheck, setCurrentPageCheck] = useState(0); // currentPageCheck 추가
    const element = useRoutes([
        { path: "/daejeon/", element: <Home /> },
        { path: "/daejeon/lobby", element: <Lobby /> },
        { path: "/daejeon/lounge", element: <Lounge /> },
        { path: "/daejeon/privateroom", element: <Privateroom /> },
        { path: "/*", element: <Navigate to="/daejeon/" replace={true} /> },
    ]);

    const location = useLocation();
    let prevScrollY;

    // 라우터 변화를 감지하여 해당 페이지에 맞는 값을 localStorage에 저장합니다.
    useEffect(() => {
        let pageValue;
        // 라우터를 감지하여 해당 페이지에 맞는 값 설정
        switch (location.pathname) {
            case "/daejeon/lobby":
                pageValue = 0;
                localStorage.removeItem("moveSectionNum");
                break;
            case "/daejeon/lounge":
                pageValue = 1;
                localStorage.removeItem("moveSectionNum");
                break;
            case "/daejeon/privateroom":
                pageValue = 2;
                localStorage.removeItem("moveSectionNum");
                break;
            default:
                pageValue = "home"; // 다른 페이지인 경우 0으로 설정하거나 필요에 따라 다른 값으로 설정할 수 있습니다.
                break;
        }

        // 페이지 값(pageValue)을 localStorage에 저장합니다.
        localStorage.setItem("pageCheck", pageValue.toString());
        // currentPageCheck 상태 업데이트
        setCurrentPageCheck(pageValue);
    }, [location.pathname]); // location.pathname이 변경될 때마다 실행되도록 설정

    function setMobileHeight() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
    useEffect(() => {
        const isVisited = getCookie("visited");

        if (isVisited || location.pathname !== "/daejeon/") {
            // 방문 이력이 있을 경우 로딩 상태를 false로 변경하여 <Loading /> 컴포넌트를 비노출합니다.
            setvisited(false);
        }

        setMobileHeight();

        // resize 이벤트가 발생하면 다시 계산하도록 아래 코드 추가
        window.addEventListener("resize", setMobileHeight);
        return () => window.removeEventListener("resize", setMobileHeight);
    }, []);

    useEffect(() => {
        // 페이지가 로드될 때 실행될 함수
        const handleScroll = () => {
            localStorage.setItem("currentScrollY", window.scrollY.toString());
        };

        window.addEventListener("scroll", handleScroll); // 스크롤 이벤트를 감지하여 핸들러 호출

        return () => {
            window.removeEventListener("scroll", handleScroll); // 컴포넌트가 언마운트 될 때 이벤트 리스너 제거
        };
    }, []); // 빈 배열을 전달하여 이펙트가 마운트 시 한 번만 실행되도록 함

    useEffect(() => {
        const handlePopstate = () => {
            // 브라우저의 뒤로가기 버튼 클릭 시 실행할 동작
            prevScrollY = localStorage.getItem("currentScrollY");
            window.scrollTo(0, prevScrollY);
        };

        window.addEventListener("popstate", handlePopstate);

        return () => {
            window.removeEventListener("popstate", handlePopstate);
        };
    }, []);

    return (
        <>
            {/* 오픈 시 주석 소스로 적용 필요 */}
            {visited && <Loading />}
            {/* 오픈 시 소스 제거 필요 */}
            {/* <Loading />  */}
            <AnimatePresence mode="wait" initial={false}>
                {React.cloneElement(element, { key: location.pathname })}
            </AnimatePresence>
        </>
    );
}
